// import { View, Text } from 'react-native'
// import React from 'react'

// const FacilitySelectionmodalTwo = () => {
//   return (
//     <View>
//       <Text>FacilitySelectionmodalTwo</Text>
//     </View>
//   )
// }

// export default FacilitySelectionmodalTwo
import React, { useEffect, useState } from "react";
import { DropDownManuCustom } from "./DropDownButton";
import Inputbox, { Inputboxphone } from "./Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  AddFacilityTwo,
  FetchFacility,
  GetProviderType,
} from "../../api/helper";
import { useSelector } from "react-redux";
import { ShowToast } from "../../helpers/ToastService";
import InputMask from "react-input-mask";

const validationSchema = Yup.object().shape({
  facilityId: Yup.string().required("Facility Selection is required"),
  fullName: Yup.string().required("Full Name is required"),
  providerType: Yup.string().required("Provider Type is required"),
  NPINumber: Yup.string().matches(/^\d{10}$/, "NPI Number must be 10 digits"),
  status: Yup.string().required("Status is required"),
});
const FacilitySelectionmodalTwo = ({ close, GetFacility }) => {
  // console.log(selectedData,'===>selectedData')
  const [providertype, setprovidertype] = useState([]);
  const [paracticedata, setparacticedata] = useState([]);
  const [selectedData, setselectedData] = useState();
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const pageSize = 1000;
  const [phone, setPhone] = useState("");
  const Fetchproviderlist = async () => {
    try {
      const response = await GetProviderType(`?id=${profiledata?._id}`);
      //   console.log(response?.data?.data, "GetProviderType======");
      setprovidertype(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const GetFacilitySelection = async (page = 1) => {
    try {
      const Respo = await FetchFacility(profiledata?._id, pageSize, page);
      // console.log(Respo?.data, "hello==========");

      const data = Respo?.data?.data?.facilities?.map((e) => {
        return {
          name: `${e.facilityName}`,
          ...e,
        };
      });
      setparacticedata(data || []);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetFacilitySelection();
    Fetchproviderlist();
  }, []);
  const {
    register,
    reset,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const onSubmit = async (data) => {
    data.agencyId = profiledata?._id;
    data.PhoneNumber = phone;
    try {
      const respo = await AddFacilityTwo(data);
      console.log(respo?.data, "respo====two====");
      ShowToast(respo?.data?.message);
      close();
      GetFacility();
    } catch (error) {
      console.log(error);
    }
  };
  const facilitiesSelect = (data) => {
    // console.log(data, "data======");
    setselectedData(data);
  };
  console.log(selectedData,"selectedData=====l==")
  return (
    <div className="modal_PatientDocuments" id="addDocumentModal">
      <div
        style={{
          fontSize: "20px",
          cursor: "pointer",
          width: 50,
          position: "absolute",
          right: 18,
          top: 27,
        }}
        onClick={close}
      >
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkP8S8v6oIxwDrJfdNdFU7FvVNZCcK025zZg&s"
          style={{ height: 20, width: 20 }}
        />
      </div>
      <div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            width: "100%",
            alignItems: "center",
            justifyItems: "center",
            marginBottom: 20,
          }}
        >
          <h1 style={{ textAlign: "left" }}>Add Member</h1>
          <div
            style={{
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <>
              <div className="form-group">
                <DropDownManuCustom
                  label="Facility Selection"
                  placeholder="Select option"
                  options={paracticedata}
                  name="facilityId"
                  defaultValue={selectedData?._id}
                  dropdownicon
                  register={register}
                  id="_id"
                  onSelect={facilitiesSelect}
                  clearErrors={clearErrors}
                  divstyle={{ marginTop: -5 }}
                />
                <p style={{ color: "red", textAlign: "left" }}>
                  {errors.facilityId?.message}
                </p>
              </div>
              <Inputbox
                label="Full Name"
                type="text"
                placeholder="Enter Full Name"
                name="fullName"
                className="Custom_input"
                register={register}
                containerstyle={{ marginTop: -10 }}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.fullName?.message}
              </p>
              <div className="form-group">
                <DropDownManuCustom
                  label="Provider Type"
                  placeholder="Select option"
                  options={providertype}
                  name="providerType"
                  dropdownicon
                  register={register}
                  id="providerType"
                  clearErrors={clearErrors}
                  divstyle={{ marginTop: -10 }}
                />
                <p style={{ color: "red", textAlign: "left" }}>
                  {errors.providerType?.message}
                </p>
              </div>
              <Inputbox
                label="NPI Number"
                type="text"
                placeholder="Enter NPI Number"
                name="NPINumber"
                className="Custom_input"
                register={register}
                containerstyle={{ marginTop: -10 }}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.NPINumber?.message}
              </p>
              {/* <Inputboxphone
        label="Phone Number"
        type="text"
        placeholder="Enter Phone Number"
        name="PhoneNumber"
        className="Custom_input"
        register={register}
      /> */}
              <Inputboxphone
                label="Phone Number"
                name="phone"
                value={phone}
                onChange={setPhone}
                containerstyle={{ marginTop: -10 }}
              />
              <div className="form-group">
                <DropDownManuCustom
                  label="Status"
                  placeholder="Select option"
                  options={[
                    { id: "1", name: "active" },
                    { id: "2", name: "Inactive" },
                    { id: "3", name: "pending" },
                  ]}
                  name="status"
                  dropdownicon
                  register={register}
                  id="status"
                  clearErrors={clearErrors}
                  divstyle={{ marginTop: -5 }}
                />
                <p style={{ color: "red", textAlign: "left" }}>
                  {errors.status?.message}
                </p>
              </div>
            </>

            <button
              type="submit"
              style={{
                marginBottom: 20,
                marginTop: 20,
                alignSelf: "center",
                width: "100%",
                height: "50px",
              }}
              className="Save_buttonnn"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FacilitySelectionmodalTwo;
